import { Injectable, signal } from '@angular/core';

/**
 * Inset inferior cuando el teclado virtual reduce visualViewport (iOS Safari / Android).
 * Fallback seguro si no existe visualViewport (inset 0).
 * Expone `--milinco-kb-inset` en documentElement para chrome admin (dock / save bar).
 */
@Injectable({ providedIn: 'root' })
export class AdminKeyboardInsetService {
  private listeners = 0;

  readonly bottomInsetPx = signal(0);

  attach(): () => void {
    if (typeof window === 'undefined' || !window.visualViewport) {
      return () => undefined;
    }

    this.listeners += 1;
    if (this.listeners === 1) {
      window.visualViewport.addEventListener('resize', this.sync);
      window.visualViewport.addEventListener('scroll', this.sync);
      this.sync();
    }

    return () => {
      this.listeners = Math.max(0, this.listeners - 1);
      if (this.listeners === 0) {
        window.visualViewport?.removeEventListener('resize', this.sync);
        window.visualViewport?.removeEventListener('scroll', this.sync);
        this.bottomInsetPx.set(0);
        document.documentElement.style.removeProperty('--milinco-kb-inset');
      }
    };
  }

  private readonly sync = (): void => {
    const viewport = window.visualViewport;
    if (!viewport) {
      return;
    }
    const inset = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
    const px = Math.round(inset);
    this.bottomInsetPx.set(px);
    document.documentElement.style.setProperty('--milinco-kb-inset', `${px}px`);
  };
}
